import { gql } from '@apollo/client/core';

const PublicPortfolioIndexPageJobsInquiryFragment = gql`
  fragment PublicPortfolioIndexPageJobsInquiryFragment on JobsInquiry {
    id
    aeLeadSourceOther
    aeLeadSourcesMain
    aeQuotaPerPeriod
    aeQuotaTypeMain
    aeQuotaTypeOther
    baseSalary
    csmAccountsNumber
    csmQuotaMetricMain
    csmQuotaMetricOther
    csmQuotaPeriodMain
    csmQuotaPeriodOther
    csmQuotaTypeMain
    csmRenewalValue
    csmTotalBusinessValue
    csmUpsellValue
    currency
    dealSize
    id
    ote
    positionMain
    positionOther
    quotaAttainmentByTeamPerPeriod
    quotaAttainmentPerLastYear
    quotaAttainmentPerPeriod
    rankOnTeam
    revenue
    salesCycleLength
    salesMethodologies
    sdrQuotaPerPeriod
    sdrQuotaTypes
    state
    teamSize
    vpDepartmentSize
    vpManagedRoles
    vpQuotaType
    filledAt
    flexState
    source
    stale
    willingToRelocate
    employmentTypes
    dealBreakersMain
    dealBreakerOther
    idealJobDescription
    desiredCompanySeriesStages {
      description
      id
      name
      slug
    }
    fakeHiring {
      candidateState
      vacancy {
        id
        employmentType
        submission {
          roleName
        }
        employer {
          id
          logoUrl
          company {
            id
            name
          }
        }
      }
    }
    activeHirings {
      id
      candidateState
      candidateStateViewed
      hashid
      schedulingLink
      vacancy {
        id
        employmentType
        submission {
          roleName
        }
        employer {
          id
          logoUrl
          company {
            id
            name
          }
        }
        primaryRecruiter {
          email
          firstname
          lastname
        }
        title
      }
    }
    hiringsForReview {
      id
      hashid
      acceptedByEmployer
      hoursToExpire
      vacancy {
        id
        employmentType
        submission {
          compensation
          oteRange {
            min
            max
          }
          openToRemoteWork
          cities {
            id
            name
            stateCode
          }
          countries {
            name
          }
          roleName
        }
        employer {
          id
          logoUrl
          company {
            id
            name
          }
        }
      }
    }
  }
`;

export default PublicPortfolioIndexPageJobsInquiryFragment;
